import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { CHECKOUT_URL, trackInitiateCheckout } from '../utils/checkout';
import { Check } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 px-4 bg-forest relative overflow-hidden" data-id="element-91" data-mp="c7k61z6m2ppe">
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-forest-light/20 via-forest to-forest pointer-events-none" data-id="element-92" data-mp="84nswnzublsu"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-93" data-mp="h6dkbttq2kqm">
        <div className="text-center mb-16" data-id="element-94" data-mp="h5lqoojoqx2z">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-8 leading-tight text-cream" data-id="element-95" data-mp="vv9o3eoqxblf">
            El próximo lunes podés seguir improvisando...
            <br data-id="element-96" data-mp="qxrq2jc9ogs7" />
            <span className="text-gold-gradient" data-id="element-97" data-mp="14vg00w4sq3ih">
              O podés entrar al aula con todo listo desde hoy.
            </span>
          </h2>

          <div className="max-w-2xl mx-auto text-left space-y-4 mb-12 bg-forest-dark p-8 rounded-2xl border border-forest-light" data-id="element-98" data-mp="zxo8i382cjet">
            {['Sin más noches buscando cómo explicar el ciclo del cultivo o la diferencia entre sistemas de riego', 'Sin más clases armadas de apuro con material que no funciona ni se adapta a tu contexto', 'Sin más alumnos desconectados que no entienden para qué sirve aprender producción agropecuaria', 'Sin más fines de semana perdidos construyendo material desde cero', 'Sin más silencios incómodos frente a preguntas técnicas que te ponen en aprietos'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-99" data-mp="34udcnb3yb98c" data-mpi={i}>
                <span className="text-gold mt-1" data-id="element-100" data-mp="39s5fh064wfrb">▸</span>
                <span className="text-cream-dark" data-id="element-101" data-mp="39rvk0x2blge8">{item}</span>
              </div>)}
          </div>

          <p className="text-xl text-cream mb-2" data-id="element-102" data-mp="3epf1e5ube9ae">
            El Mega Pack Educación Agropecuaria en el Aula no te convierte en
            mejor docente.
          </p>
          <p className="text-2xl font-bold text-gold mb-6" data-id="element-103" data-mp="1jp4tzpvaoznc">
            Vos ya sos un buen docente.
          </p>
          <p className="text-xl text-cream-dark mb-16" data-id="element-104" data-mp="1eqtm3kok8z7r">
            Lo que hace el Mega Pack es darte el tiempo y las herramientas para
            que eso se note en cada clase, en cada práctica, en cada proyecto
            que tus alumnos llevan al campo.
          </p>
        </div>

        <div className="bg-white border-2 border-gold/50 rounded-3xl p-8 md:p-12 shadow-[0_0_40px_rgba(212,175,55,0.2)]" data-id="element-105" data-mp="22djjg8pys5m1">
          <h3 className="text-2xl font-bold text-slate-900 mb-6 text-center border-b border-earth/20 pb-6" data-id="element-106" data-mp="1xfhytjcw3y8g">
            Todo lo que incluye:
          </h3>

          <div className="grid md:grid-cols-2 gap-x-8 gap-y-4 mb-10" data-id="element-107" data-mp="27do3g8q2zih0">
            {['Tomo 1 — Fundamentos de la Producción Agropecuaria', 'Tomo 2 — Producción Vegetal y Ganadería Bovina', 'Tomo 3 — Riego, Maquinaria y Seguridad Rural', 'Tomo 4 — Sustentabilidad y Producción Animal', 'Tomo 5 — Del Campo al Mercado', 'Bono 1 — Clases organizadas y listas para usar', 'Bono 2 — Actividades prácticas para el aula y el taller', 'Bono 3 — Evaluaciones y criterios de corrección', 'Bono 4 — Proyectos Finales Productivos', 'Garantía de 7 días sin preguntas', 'Pago en tu moneda local', 'Acceso inmediato', 'Formato PDF listo para usar'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-108" data-mp="3ka3ezmontsw0" data-mpi={i}>
                <Check size={18} className="text-forest shrink-0" data-id="element-109" data-mp="36dzysxamfl2j" />
                <span className="text-sm text-slate-700" data-id="element-110" data-mp="3bb9nubu3lupu">{item}</span>
              </div>)}
          </div>

          <div className="text-center" data-id="element-111" data-mp="14md86wun5s6l">
            <div className="mb-8 p-6 bg-cream rounded-xl border border-earth/20 italic text-slate-700 text-lg shadow-sm" data-id="element-112" data-mp="14j8sb27td803">
              "El mejor momento para tener este material era al inicio del año.
              <br data-id="element-113" data-mp="35l6zyi1lhtdz" />
              <span className="text-forest font-bold not-italic" data-id="element-114" data-mp="30oq0iroy3sll">
                El segundo mejor momento es hoy.
              </span>
              "
            </div>

            <p className="text-xl font-serif font-bold text-slate-900 mb-2" data-id="element-115" data-mp="2vrgelm0rlz2i">
              📚 Mega Pack Educación Agropecuaria en el Aula
            </p>
            <p className="text-sm text-slate-500 mb-8" data-id="element-116" data-mp="2moytxc0rdehm">
              Hecho por especialistas, para docentes técnicos y rurales de todo
              el mundo hispanohablante.
            </p>

            <Button href={CHECKOUT_URL} onLinkClick={trackInitiateCheckout} className="w-full md:w-auto text-xl py-6 px-12 mb-6" data-id="element-117" data-mp="2cy44jys7tyry">
              🟡 QUIERO MI MEGA PACK AHORA
            </Button>

            <div className="flex flex-wrap justify-center gap-4 text-xs text-slate-500 font-medium" data-id="element-118" data-mp="240a88nugb54s">
              <span data-id="element-119" data-mp="1z17cxv49wda0">✅ Garantía de 7 días</span>
              <span data-id="element-120" data-mp="ehv710segcar">✅ Pago seguro</span>
              <span data-id="element-121" data-mp="egsk13y76u04">✅ Acceso inmediato</span>
              <span data-id="element-122" data-mp="jfnbeua8dqvu">✅ Pagás en tu moneda local</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}